import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material";
import { LanguageConsumer } from "../../../../../../Infrastructure/Internationalisation/TranslationService";
import { fetchMyDepragApi } from "../../../../../../Infrastructure/Api/ApiBaseCall";
import { RootState, store } from "../../../../../../Infrastructure/Store/store";
import { useAppDispatch, useAppSelector } from "../../../../../../Infrastructure/Store/hooks";
import { toggleMessagePopup } from "../Store/DeleteMessagesPopupSlice";

export interface DeleteMessagePopupProps{
    idToDelete: number
}

export const DeleteMessagePopup = (props: DeleteMessagePopupProps) => {
    const dispatch = useAppDispatch();
    const { deletePopupVisible } = useAppSelector(store => store.deleteMessage);

    const handleDelete = async () => {
        await fetchMyDepragApi(null, "highlevel/maintenance/delete/" + props.idToDelete, 'POST', dispatch, store.getState() as RootState);
        closeDialog();
    }

    const closeDialog = () => {
        dispatch(toggleMessagePopup());
    }
    
    return(
        <>
            <LanguageConsumer>
            {({getTranslatedText}) => 
                <Dialog open={deletePopupVisible} >
                    <DialogTitle >
                        {getTranslatedText("AreYouSure")}
                    </DialogTitle>

                    <DialogContent >
                        <DialogContentText >
                            {getTranslatedText("HighLevelMaintenanceDeleteMessage")}
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <Button variant="outlined" color="darky" onClick={closeDialog}>{getTranslatedText("CommonCancel")}</Button>
                        <Button variant="outlined" color="error" onClick={async () => await handleDelete()} autoFocus>
                            {getTranslatedText("DeleteMessage")}
                        </Button>
                    </DialogActions>
                </Dialog>
            }
            </LanguageConsumer>
        </>
    );
}